import { Routes } from '@angular/router';

import { LoginComponent } from './authentication/login/login.component';
import { HomeComponent } from './pages/home/home.component';

export const APP_ROUTES: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: HomeComponent,
    children: [
        { path: 'dashboard', loadChildren: './pages/dashboards/dashboard.module#DashboardModule' },
        { path: 'proceso', loadChildren: './pages/proceso/proceso.module#ProcesoModule' },
        { path: 'catalogos', loadChildren: './pages/catalogos/catalogo.module#CatalogoModule' },
        { path: 'administracion', loadChildren: './pages/administracion/administracion.module#AdministracionModule' },
        { path: 'procesoTHD', loadChildren: './pages/procesoTHD/proceso.thd.module#ProcesoTHDModule' },
        { path: 'noPermiso', loadChildren: './nopermiso/nopermiso.module#NoPermisoModule' },
        { path: 'cuenta', loadChildren: './pages/cuenta/cuenta.module#CuentaModule' },
        { path: '', redirectTo: 'dashboard/pedidos', pathMatch: 'full' }
    ]
  }
];
